import {
  Action,
  Menu,
} from '../../components/Account/AccountDropDown/AccountDropDown.styled';

import { AnchorButton } from '../../shared/Anchor/Anchor.styled';
import { BackdropWrapper } from '../BackdropOverlay/BackdropOverlay.styled';
import { PalletteProps } from '../../types/theme/pallette';
import styled from 'styled-components';

export const StyledBackdropWrapper = styled(BackdropWrapper)`
  position: fixed;
  top: 0;
`;

export const SidebarWrapper = styled.div`
  height: 100vh;
  width: 310px;
  position: fixed;
  z-index: 1000;
  top:0;
  left: 0;
  background-color: ${({ theme }: PalletteProps) => theme.white};
  transition: 0.5s;
  padding-top: 46px;
  overflow: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
  ${AnchorButton} {
    padding: 0;
    width: 107px;
    height: 45px;
    margin-left: 30px;
    @media ${({ theme }: PalletteProps) => theme.breakpoints.tablet} {
      display: none;
    }
  }
  ${Action} {
    padding: 0;
    top: 0;
    left: 0;
    margin-left: 30px;
    @media ${({ theme }: PalletteProps) => theme.breakpoints.tablet} {
      display: none;
    }
  }
  ${Menu} {
    top: 10px;
    left: -10px;
    border: 0;
    margin-left: 30px;
    position: relative;
    @media ${({ theme }: PalletteProps) => theme.breakpoints.tablet} {
      display: none;
    }
  }
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobile} {
    width: 500px;
  }
  @media ${({ theme }: PalletteProps) => theme.breakpoints.laptopM} {
    display: none;
  }
`;

export const SidebarCloseButton = styled.button`
  position: absolute;
  top: 17px;
  right: 19px;
  font-size: 36px;
  text-decoration: none;
  background: transparent;
  border: none;
  outline: 0;
  cursor: pointer;
  padding: 8px 12px;
  background-color: ${({ theme }: PalletteProps) => theme.gray5};
  color: ${({ theme }: PalletteProps) => theme.darkGray};
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const SidebarDivider = styled.div`
  max-width: 100%;
  height: 1.5px;
  background-color: ${({ theme }: PalletteProps) => theme.gray4};
  margin: 20px;
  @media ${({ theme }: PalletteProps) => theme.breakpoints.tablet} {
    background-color: transparent;
  }
`;

export const CategoriesTitle = styled.h2`
  font-size: 20px;
  font-weight: 900;
  line-height: 24.2px;
  padding-left: 30px;
`;

export const CategoriesSidebarMenu = styled.ul`
  padding: 0;
  margin-bottom: 40px;
  list-style: none;
  .sidebarActiveCategory {
    background-color: ${({ theme }: PalletteProps) => theme.gray9};
  }
`;

export const MenuItemSidebar = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 30px;
  font-size: 1rem;
  transition: ease all 200ms;
  &:hover {
    background: ${({ theme }: PalletteProps) => theme.gray10};
  }
  .sidebarAngleIcon {
    color: ${({ theme }: PalletteProps) => theme.primaryColor};
  }
`;

export const CategoryProductCount = styled.div`
  color: ${({ theme }: PalletteProps) => theme.gray11};
`;
